import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import BackToPreviousPageButton from '../../../components/Button/BackToPreviousPageButton';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import {
  SegmentedView,
  SegmentedViewController,
  SegmentedViewData,
} from '../../../components/SegmentedViewController/SegmentedViewOnLine';
import useDriverDetails from '../../../hooks/dashboard/driver-list/useDriverDetails';
import { DRIVER_LIST } from '../../../routes/routeConstants';
import DriverBioArea from './DriverBioArea';
import FeedbackAnalysis from './FeedbackAnalysis';
import MangeDriverDropDown from './MangeDriverDropDown';
import PerformanceIndex from './PerformanceIndex';

const segmentedViewControllerTitle = [
  { title: 'Performance Index' },
  { title: 'Feedback Analysis' },
];

const DriverPerformanceReport = () => {
  const { ninNumber, driverId, name, verificationStatus } = useParams();
  const { pathname } = useLocation();
  const { getDriverDetails, driverDetailsData } = useDriverDetails();
  const [refreshData, setRefreshData] = useState(0);

  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Driver List`,
        link: `/${DRIVER_LIST}`,
      },

      {
        name: `Results for: ${name}`,
        link: pathname,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getDriverDetails(driverId ?? '');
    // eslint-disable-next-line
  }, [driverId]);

  return (
    <Page title='Logirate | Driver List'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />
        <BackToPreviousPageButton
          path={DRIVER_LIST}
          compFn={() => {
            const comp =
              driverDetailsData?.employmentStatus === 'Exited' ? (
                <div></div>
              ) : (
                <MangeDriverDropDown
                  data={{
                    driverId,
                    name,
                    ninNumber,
                    verificationStatus,
                    ...driverDetailsData,
                  }}
                  driverDetailsData={driverDetailsData}
                  setRefreshData={setRefreshData}
                />
              );
            return comp;
          }}
        />

        <Container>
          <HeaderArea>
            <DriverBioArea data={driverDetailsData} />
          </HeaderArea>
          <BoldText>Performance Index</BoldText>

          <SegmentsArea>
            <SegmentedView>
              <SegmentedViewController
                segmentedViewControllerTitle={segmentedViewControllerTitle}
              />
              <SegmentedViewData>
                <section>
                  <PerformanceIndex
                    driverDetailsData={driverDetailsData}
                    refreshData={refreshData}
                  />
                </section>
                <section>
                  <FeedbackAnalysis />
                </section>
              </SegmentedViewData>
            </SegmentedView>
          </SegmentsArea>
        </Container>
      </PageLayout>
    </Page>
  );
};

export default DriverPerformanceReport;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  /* border: 1px solid red; */
`;

const HeaderArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const BoldText = styled.div`
  font-weight: 700;
  font-size: 18px;
`;

const SegmentsArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: white;
`;
